import { render, staticRenderFns } from "./ScreeningDocumentEdit.vue?vue&type=template&id=8b81800a"
import script from "./ScreeningDocumentEdit.vue?vue&type=script&lang=ts"
export * from "./ScreeningDocumentEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports